/**
 * Pumps Customization Simulator Data
 * Complete 87-color palette with materials, options, and types
 */

// ============================================
// COLOR DATA (87 colors from CSV)
// ============================================
const COLORS = [
  { id: 'suede-805', name: '805', displayName: 'オフベージュ', code: '9E8D71', material: 'suede', kobeCode: '805' },
  { id: 'suede-291', name: '291', displayName: 'アプリコット', code: 'C8907A', material: 'suede', kobeCode: '291' },
  { id: 'suede-642', name: '642', displayName: 'グレージュ', code: '8A7260', material: 'suede', kobeCode: '642' },
  { id: 'suede-125', name: '125', displayName: 'シクラメン', code: 'D4AABC', material: 'suede', kobeCode: '125' },
  { id: 'suede-01', name: '01', displayName: 'オフホワイト', code: 'CFD4D4', material: 'suede', kobeCode: '01' },
  { id: 'suede-292', name: '292', displayName: 'アンバー', code: 'A26621', material: 'suede', kobeCode: '292' },
  { id: 'suede-1010', name: '1010', displayName: 'オーク', code: 'A08870', material: 'suede', kobeCode: '1010' },
  { id: 'suede-307', name: '307', displayName: 'ライトピンク', code: 'C3A6AA', material: 'suede', kobeCode: '307' },
  { id: 'suede-02', name: '02', displayName: 'ベージュ', code: 'BDB993', material: 'suede', kobeCode: '02' },
  { id: 'suede-1002', name: '1002', displayName: 'ライトキャメル', code: 'C8A870', material: 'suede', kobeCode: '1002' },
  { id: 'suede-138', name: '138', displayName: 'カッパー', code: '571104', material: 'suede', kobeCode: '138' },
  { id: 'suede-308', name: '308', displayName: 'ラズベリー', code: 'E8207A', material: 'suede', kobeCode: '308' },
  { id: 'suede-03', name: '03', displayName: 'クリーム', code: 'CDC6A8', material: 'suede', kobeCode: '03' },
  { id: 'suede-1003', name: '1003', displayName: 'オークベージュ', code: 'A08060', material: 'suede', kobeCode: '1003' },
  { id: 'suede-139', name: '139', displayName: 'ココア', code: '6A3820', material: 'suede', kobeCode: '139' },
  { id: 'suede-312', name: '312', displayName: 'マゼンタ', code: '830A40', material: 'suede', kobeCode: '312' },
  { id: 'suede-502', name: '502', displayName: '黄ベージュ', code: 'C0B381', material: 'suede', kobeCode: '502' },
  { id: 'suede-1004', name: '1004', displayName: 'ライトオーク', code: 'B09878', material: 'suede', kobeCode: '1004' },
  { id: 'suede-1011', name: '1011', displayName: 'ブラウン', code: '2C0E08', material: 'suede', kobeCode: '1011' },
  { id: 'suede-309', name: '309', displayName: 'ルビー', code: '800050', material: 'suede', kobeCode: '309' },
  { id: 'suede-1001', name: '1001', displayName: 'ピンクベージュ', code: 'EDD8C8', material: 'suede', kobeCode: '1001' },
  { id: 'suede-997', name: '997', displayName: 'キャメルブラウン', code: '724313', material: 'suede', kobeCode: '997' },
  { id: 'suede-1012', name: '1012', displayName: 'ダークブラウン', code: '1E1008', material: 'suede', kobeCode: '1012' },
  { id: 'suede-135', name: '135', displayName: 'バナナイエロー', code: 'C8B060', material: 'suede', kobeCode: '135' },
  { id: 'suede-306', name: '306', displayName: 'サンドベージュ', code: 'B5ACA2', material: 'suede', kobeCode: '306' },
  { id: 'suede-998', name: '998', displayName: 'ライトブラウン', code: '6E3619', material: 'suede', kobeCode: '998' },
  { id: 'suede-1013', name: '1013', displayName: 'ダークセピア', code: '604838', material: 'suede', kobeCode: '1013' },
  { id: 'suede-136', name: '136', displayName: 'イエロー', code: 'BE992D', material: 'suede', kobeCode: '136' },
  { id: 'suede-777', name: '777', displayName: 'アンテロープ', code: 'A49583', material: 'suede', kobeCode: '777' },
  { id: 'suede-1029', name: '1029', displayName: 'サイプラスブラウン', code: '8B2B07', material: 'suede', kobeCode: '1029' },
  { id: 'suede-290', name: '290', displayName: 'サーモンピンク', code: 'E88870', material: 'suede', kobeCode: '290' },
  { id: 'suede-44', name: '44', displayName: 'ライムグリーン', code: 'B8D090', material: 'suede', kobeCode: '44' },
  { id: 'suede-610', name: '610', displayName: 'スプリングリーフ', code: '6C9A6F', material: 'suede', kobeCode: '610' },
  { id: 'suede-122', name: '122', displayName: 'ラベンダー', code: '755484', material: 'suede', kobeCode: '122' },
  { id: 'suede-296', name: '296', displayName: 'オレンジ', code: 'D84600', material: 'suede', kobeCode: '296' },
  { id: 'suede-48', name: '48', displayName: 'サバンナ', code: '6D7D18', material: 'suede', kobeCode: '48' },
  { id: 'suede-602', name: '602', displayName: 'クリアミント', code: '79A6A1', material: 'suede', kobeCode: '602' },
  { id: 'suede-23', name: '23', displayName: 'パンジー', code: '57165F', material: 'suede', kobeCode: '23' },
  { id: 'suede-297', name: '297', displayName: 'キャロットオレンジ', code: 'A9500A', material: 'suede', kobeCode: '297' },
  { id: 'suede-618', name: '618', displayName: 'エメラルド', code: '098E70', material: 'suede', kobeCode: '618' },
  { id: 'suede-606', name: '606', displayName: 'スカイ', code: '96A3A9', material: 'suede', kobeCode: '606' },
  { id: 'suede-22', name: '22', displayName: 'パープル', code: '45184B', material: 'suede', kobeCode: '22' },
  { id: 'suede-27', name: '27', displayName: 'ボルドー', code: '470F11', material: 'suede', kobeCode: '27' },
  { id: 'suede-617', name: '617', displayName: 'コバルトグリーン', code: '006840', material: 'suede', kobeCode: '617' },
  { id: 'suede-607', name: '607', displayName: 'コバルトブルー', code: '14578B', material: 'suede', kobeCode: '607' },
  { id: 'suede-21', name: '21', displayName: 'ダークパープル', code: '3E1830', material: 'suede', kobeCode: '21' },
  { id: 'suede-26', name: '26', displayName: 'ワイン', code: '4F0809', material: 'suede', kobeCode: '26' },
  { id: 'suede-20', name: '20', displayName: 'グリーン', code: '154F3B', material: 'suede', kobeCode: '20' },
  { id: 'suede-608', name: '608', displayName: 'ブルー', code: '1848C8', material: 'suede', kobeCode: '608' },
  { id: 'suede-04', name: '04', displayName: 'サンドグレー', code: 'A7A4A8', material: 'suede', kobeCode: '04' },
  { id: 'suede-25', name: '25', displayName: 'バイオレット', code: '6A1A70', material: 'suede', kobeCode: '25' },
  { id: 'suede-220', name: '220', displayName: 'エバーグリーン', code: '021D10', material: 'suede', kobeCode: '220' },
  { id: 'suede-1014', name: '1014', displayName: 'ロイヤルブルー', code: '001362', material: 'suede', kobeCode: '1014' },
  { id: 'suede-929', name: '929', displayName: 'グレー', code: '585151', material: 'suede', kobeCode: '929' },
  { id: 'suede-501', name: '501', displayName: 'ワインレッド', code: '690906', material: 'suede', kobeCode: '501' },
  { id: 'suede-219', name: '219', displayName: 'デジタルオリーブ', code: '3A4828', material: 'suede', kobeCode: '219' },
  { id: 'suede-1015', name: '1015', displayName: 'インディゴ', code: '243660', material: 'suede', kobeCode: '1015' },
  { id: 'suede-930', name: '930', displayName: 'ダークグレー', code: '2E2C2C', material: 'suede', kobeCode: '930' },
  { id: 'suede-449', name: '449', displayName: 'レッド', code: 'AF0701', material: 'suede', kobeCode: '449' },
  { id: 'suede-19', name: '19', displayName: 'オリーブ', code: '3E3B11', material: 'suede', kobeCode: '19' },
  { id: 'suede-1016', name: '1016', displayName: 'ネービー', code: '0A1840', material: 'suede', kobeCode: '1016' },
  { id: 'suede-940', name: '940', displayName: 'チャコール', code: '252115', material: 'suede', kobeCode: '940' },
  { id: 'suede-505', name: '505', displayName: 'カーキブラウン', code: '7A6A30', material: 'suede', kobeCode: '505' },
  { id: 'suede-PS-02', name: 'PS-02', displayName: 'シャトルーズ', code: 'FEEE99', material: 'suede', kobeCode: 'PS-02' },
  { id: 'suede-PS-03', name: 'PS-03', displayName: 'イエロー', code: 'FCCD0F', material: 'suede', kobeCode: 'PS-03' },
  { id: 'suede-PS-04', name: 'PS-04', displayName: 'グリーン', code: '7BB54A', material: 'suede', kobeCode: 'PS-04' },
  { id: 'suede-PS-05', name: 'PS-05', displayName: 'ブルー', code: '5BC1C5', material: 'suede', kobeCode: 'PS-05' },
  { id: 'suede-PS-06', name: 'PS-06', displayName: 'ローズ', code: 'F52566', material: 'suede', kobeCode: 'PS-06' },
  { id: 'suede-PS-07', name: 'PS-07', displayName: 'クリーム', code: 'E8D9B5', material: 'suede', kobeCode: 'PS-07' },
  { id: 'suede-PS-08', name: 'PS-08', displayName: 'アプリコット', code: 'FFD0B8', material: 'suede', kobeCode: 'PS-08' },
  { id: 'suede-PS-09', name: 'PS-09', displayName: 'ピンク', code: 'F0B8A0', material: 'suede', kobeCode: 'PS-09' },
  { id: 'suede-PS-10', name: 'PS-10', displayName: 'オレンジ', code: 'FF7840', material: 'suede', kobeCode: 'PS-10' },
  { id: 'suede-PS-11', name: 'PS-11', displayName: 'カメリア', code: 'F06878', material: 'suede', kobeCode: 'PS-11' },
  { id: 'suede-PS-12', name: 'PS-12', displayName: 'スカーレット', code: 'E92106', material: 'suede', kobeCode: 'PS-12' },
    { id: 'suede-620', name: '620', displayName: 'ナイルブルー', code: '3A8898', material: 'suede', kobeCode: '620' },
  { id: 'suede-935', name: '935', displayName: 'アースグレー', code: '706858', material: 'suede', kobeCode: '935' },
  { id: 'suede-1000', name: '1000', displayName: '黒', code: '1A1818', material: 'suede', kobeCode: '1000' },
  { id: 'suede-EP-0000', name: 'EP-0000', displayName: '純白', code: 'F7F6F2', material: 'suede', kobeCode: 'EP-0000' },
  { id: 'goat-GS01', name: 'GS01', displayName: 'オフホワイト', code: 'D3D1C0', material: 'goat', kobeCode: 'GS01' },
  { id: 'goat-GS1002', name: 'GS1002', displayName: 'キャメル', code: 'AD792C', material: 'goat', kobeCode: 'GS1002' },
  { id: 'goat-GS606', name: 'GS606', displayName: 'クリアミント', code: '97B3BA', material: 'goat', kobeCode: 'GS606' },
  { id: 'goat-GS03', name: 'GS03', displayName: 'アイボリー', code: 'CAC4B5', material: 'goat', kobeCode: 'GS03' },
  { id: 'goat-GS997', name: 'GS997', displayName: 'キャメルブラウン', code: '965D18', material: 'goat', kobeCode: 'GS997' },
  { id: 'goat-GS2005', name: 'GS2005', displayName: 'コバルトブルー', code: '3CACB9', material: 'goat', kobeCode: 'GS2005' },
  { id: 'goat-GS502', name: 'GS502', displayName: 'ベージュ', code: 'D7C091', material: 'goat', kobeCode: 'GS502' },
  { id: 'goat-GS505', name: 'GS505', displayName: 'カーキブラウン', code: '845A18', material: 'goat', kobeCode: 'GS505' },
  { id: 'goat-GS618', name: 'GS618', displayName: 'エメラルド', code: '2DB69F', material: 'goat', kobeCode: 'GS618' },
  { id: 'goat-GS1001', name: 'GS1001', displayName: 'ピンクベージュ', code: 'CFBD99', material: 'goat', kobeCode: 'GS1001' },
  { id: 'goat-GS998', name: 'GS998', displayName: 'ブラウン', code: '481A09', material: 'goat', kobeCode: 'GS998' },
  { id: 'goat-GS2004', name: 'GS2004', displayName: 'レタスグリーン', code: '78A129', material: 'goat', kobeCode: 'GS2004' },
  { id: 'goat-GS777', name: 'GS777', displayName: 'アンテロープ', code: 'B29C7E', material: 'goat', kobeCode: 'GS777' },
  { id: 'goat-GS139', name: 'GS139', displayName: 'ココア', code: '401F0C', material: 'goat', kobeCode: 'GS139' },
  { id: 'goat-GS44', name: 'GS44', displayName: 'ライムグリーン', code: 'A5BA85', material: 'goat', kobeCode: 'GS44' },
  { id: 'goat-GS780', name: 'GS780', displayName: 'グレージュ', code: '604520', material: 'goat', kobeCode: 'GS780' },
  { id: 'goat-GS1011', name: 'GS1011', displayName: 'チョコ', code: '210D06', material: 'goat', kobeCode: 'GS1011' },
  { id: 'goat-GS48', name: 'GS48', displayName: 'サバンナ', code: '7D8227', material: 'goat', kobeCode: 'GS48' },
  { id: 'goat-GS1003', name: 'GS1003', displayName: 'オークベージュ', code: '856237', material: 'goat', kobeCode: 'GS1003' },
  { id: 'goat-GS1012', name: 'GS1012', displayName: 'ダークセビア', code: '1E1008', material: 'goat', kobeCode: 'GS1012' },
  { id: 'goat-GS19', name: 'GS19', displayName: 'オリーブ', code: '585014', material: 'goat', kobeCode: 'GS19' },
  { id: 'goat-GS1005', name: 'GS1005', displayName: 'ココナッツ', code: '65482A', material: 'goat', kobeCode: 'GS1005' },
  { id: 'goat-GS937', name: 'GS937', displayName: 'ダークオーク', code: '2A180C', material: 'goat', kobeCode: 'GS937' },
  { id: 'goat-GS20', name: 'GS20', displayName: 'グリーン', code: '083320', material: 'goat', kobeCode: 'GS20' },
  { id: 'goat-GS125', name: 'GS125', displayName: 'シクラメン', code: 'D7AC9B', material: 'goat', kobeCode: 'GS125' },
  { id: 'goat-GS2002', name: 'GS2002', displayName: 'シトラス', code: 'CFC274', material: 'goat', kobeCode: 'GS2002' },
  { id: 'goat-GS929', name: 'GS929', displayName: 'グレー', code: '71666A', material: 'goat', kobeCode: 'GS929' },
  { id: 'goat-GS290', name: 'GS290', displayName: 'アプリコット', code: 'D38655', material: 'goat', kobeCode: 'GS290' },
  { id: 'goat-GS2003', name: 'GS2003', displayName: 'イエロー', code: 'D79000', material: 'goat', kobeCode: 'GS2003' },
  { id: 'goat-GS930', name: 'GS930', displayName: 'ダークグレー', code: '1C1B17', material: 'goat', kobeCode: 'GS930' },
  { id: 'goat-GS2009', name: 'GS2009', displayName: 'ピンク', code: 'E19472', material: 'goat', kobeCode: 'GS2009' },
  { id: 'goat-GS135', name: 'GS135', displayName: 'バナナイエロー', code: 'E6B33E', material: 'goat', kobeCode: 'GS135' },
  { id: 'goat-GS940', name: 'GS940', displayName: 'チャコールグレー', code: '1A1513', material: 'goat', kobeCode: 'GS940' },
  { id: 'goat-GS308', name: 'GS308', displayName: 'ショッキングピンク', code: 'CA3454', material: 'goat', kobeCode: 'GS308' },
  { id: 'goat-GS296', name: 'GS296', displayName: 'オレンジ', code: 'DC5D00', material: 'goat', kobeCode: 'GS296' },
  { id: 'goat-GS1015', name: 'GS1015', displayName: 'インディゴ', code: '0B1528', material: 'goat', kobeCode: 'GS1015' },
  { id: 'goat-GS23', name: 'GS23', displayName: 'パープル', code: '773571', material: 'goat', kobeCode: 'GS23' },
  { id: 'goat-GS298', name: 'GS298', displayName: 'レンガ', code: 'B61F0A', material: 'goat', kobeCode: 'GS298' },
  { id: 'goat-GS1016', name: 'GS1016', displayName: 'ネービー', code: '070915', material: 'goat', kobeCode: 'GS1016' },
  { id: 'goat-GS22', name: 'GS22', displayName: 'バイオレット', code: '4F1848', material: 'goat', kobeCode: 'GS22' },
  { id: 'goat-GS26', name: 'GS26', displayName: 'ワイン', code: '540B11', material: 'goat', kobeCode: 'GS26' },
  { id: 'goat-GS1000', name: 'GS1000', displayName: 'ブラック', code: '040402', material: 'goat', kobeCode: 'GS1000' },
  { id: 'goat-GS449', name: 'GS449', displayName: 'レッド', code: 'C20B09', material: 'goat', kobeCode: 'GS449' },
  { id: 'smooth-508', name: 'black', displayName: 'ブラック', code: '000000', material: 'smooth', kobeCode: 'ブラック' },
  { id: 'smooth-600', name: 'white', displayName: 'ホワイト', code: 'FFFFFF', material: 'smooth', kobeCode: 'ホワイト' },
  { id: 'smooth-695', name: 'beige', displayName: 'ベージュ', code: 'B99983', material: 'smooth', kobeCode: 'ベージュ' },
  { id: 'smooth-545', name: 'orange', displayName: 'オレンジ', code: 'D4926A', material: 'smooth', kobeCode: 'オレンジ' },
  { id: 'smooth-524', name: 'pink', displayName: 'ピンク', code: 'EFBCB9', material: 'smooth', kobeCode: 'ピンク' },
  { id: 'enamel-black', name: 'black', displayName: 'エナメル ブラック', code: '1A1A2E', material: 'enamel', kobeCode: 'エナメルブラック' },
  { id: 'enamel-navy', name: 'navy', displayName: 'エナメル ネイビー', code: '1E2D5A', material: 'enamel', kobeCode: 'エナメルネイビー' },
  { id: 'enamel-pink', name: 'pink', displayName: 'エナメル ピンク', code: 'C08898', material: 'enamel', kobeCode: 'エナメルピンク' },
  { id: 'enamel-spring', name: 'cream', displayName: 'エナメル スプリングベージュ', code: 'FCEABA', material: 'enamel', kobeCode: 'エナメルスプリング' },
  { id: 'enamel-summer', name: 'beige', displayName: 'エナメル サマーベージュ', code: 'B0A898', material: 'enamel', kobeCode: 'エナメルサマー' },
  { id: 'enamel-autumn', name: 'oak_brown', displayName: 'エナメル オータムベージュ', code: 'A07850', material: 'enamel', kobeCode: 'エナメルオータム' },
  { id: 'enamel-winter', name: 'cream', displayName: 'エナメル ウィンターベージュ', code: 'E8E0D0', material: 'enamel', kobeCode: 'エナメルウィンター' }
];

// ============================================
// PUMPS TYPES
// ============================================
const PUMPS_TYPES = [
  { id: '0cm', name: '0cm', label: '0cm', image: 'images/heel/0cm.webp', displayOrder: 1 },
  { id: '3cm', name: '3cm', label: '3cm', image: 'images/heel/3cm.webp', displayOrder: 2 },
  { id: '6cm', name: '6cm', label: '6cm', image: 'images/heel/6cm.webp', displayOrder: 3 },
  { id: '9cm', name: '9cm', label: '9cm', image: 'images/heel/9cm.webp', displayOrder: 4 },
  { id: 'chunky', name: 'chunky', label: 'CHUNKY', image: 'images/heel/chunky.webp', priceAdd: 2200, displayOrder: 5 },
];

// ============================================
// MATERIALS
// ============================================
const MATERIALS = [
  { id: 'suede', name: 'suede', displayName: 'スエード' },
  { id: 'smooth', name: 'smooth', displayName: 'スムース' },
  { id: 'enamel', name: 'enamel', displayName: 'エナメル' },
  { id: 'goat', name: 'goat', displayName: 'ゴート' },
];

// ============================================
// SOLES
// ============================================
const SOLES = [
  { id: 'redsole', name: 'redsole', displayName: 'レッドソール' },
  { id: 'blacksole', name: 'blacksole', displayName: 'ブラックソール' },
  { id: 'beigesole', name: 'beigesole', displayName: 'ベージュソール' },
];

// ============================================
// STRAPS
// ============================================
const STRAPS = [
  { id: 'none', name: 'none', displayName: 'なし' },
  { id: 'black', name: 'black', displayName: 'ブラック', colorCode: '000000' },
  { id: 'white', name: 'white', displayName: 'ホワイト', colorCode: 'FFFFFF' },
  { id: 'nude', name: 'nude', displayName: 'ヌード', colorCode: 'E8C9A8' },
  { id: 'red', name: 'red', displayName: 'レッド', colorCode: 'C80000' },
  { id: 'navy', name: 'navy', displayName: 'ネイビー', colorCode: '1D3557' },
];

// ============================================
// BIJOUS (装飾)
// ============================================
const BIJOUS = [
  { id: 'none',     displayName: 'なし',         image: null },
  { id: 'drop',     displayName: 'ドロップ',      image: 'images/bijou/drop.webp' },
  { id: 'orange',   displayName: 'オレンジ',      image: 'images/bijou/orange.webp' },
  { id: 'pearl_a',  displayName: 'パール A',     image: 'images/bijou/pearl_a.webp' },
  { id: 'pearl_b',  displayName: 'パール B',     image: 'images/bijou/pearl_b.webp' },
  { id: 'pearl_c',  displayName: 'パール C',     image: 'images/bijou/pearl_c.webp' },
  { id: 'pearl_d',  displayName: 'パール D',     image: 'images/bijou/pearl_d.webp' },
  { id: 'square_a', displayName: 'スクエア A',   image: 'images/bijou/square_a.webp' },
  { id: 'square_b', displayName: 'スクエア B',   image: 'images/bijou/square_b.webp' },
];

// ============================================
// VIEW ANGLES
// ============================================
const VIEWS = [
  { id: 'front', name: 'front', displayName: '前面' },
  { id: 'side', name: 'side', displayName: '側面' },
];

// Export for use in HTML
window.PumpsSimulatorData = {
  COLORS,
  PUMPS_TYPES,
  MATERIALS,
  SOLES,
  STRAPS,
  BIJOUS,
  VIEWS,
  
  getColorsByMaterial(material) {
    return COLORS.filter(c => c.material === material);
  },
  
  getAllColors() {
    return COLORS;
  },
  
  getColor(id) {
    return COLORS.find(c => c.id === id);
  },
};
